import { TApplicationState } from '../../types/redux';
import { getBanks } from './getBanks';

export const getHasBanks = (state: TApplicationState): boolean => {
  const banks = getBanks(state);

  return banks.length > 0;
};
